import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PrivateSale from "./pages/PrivateSale";
import VillageBike from "./pages/VillageBike";
import PrivateSaleHosts from "./pages/PrivateSaleHosts";
import RushHour from "./pages/RushHour";
import RushHourHosts from "./pages/RushHourHosts";
import Nike1Year from "./pages/Nike1Year";
import ScratchAndWin from "./pages/ScratchAndWin";
import ScratchAndWinHosts from "./pages/ScratchAndWinHosts";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/private-sale" element={<PrivateSale />} />
          <Route path="/villagebike" element={<VillageBike />} />
          <Route path="/private-sale-hosts" element={<PrivateSaleHosts />} />
          <Route path="/rushhour" element={<RushHour />} />
          <Route path="/rushhour-hosts" element={<RushHourHosts />} />
          <Route path="/Nike1Year" element={<Nike1Year />} />
          <Route path="/nike1year" element={<Nike1Year />} />
          <Route path="/ScratchAndWin" element={<ScratchAndWin />} />
          <Route path="/scratchandwin" element={<ScratchAndWin />} />
          <Route path="/ScratchAndWinHosts" element={<ScratchAndWinHosts />} />
          <Route path="/scratchandwinhosts" element={<ScratchAndWinHosts />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
